import {Client, IMessage} from "@stomp/stompjs";
import SockJS from "sockjs-client";

class WebSocketService {
    private client: Client | null = null;
    private subscriptions: Map<string, () => void> = new Map();
    private isConnected = false;

    connect(onConnect?: () => void) {
        if (this.client?.active) return;

        this.client = new Client({
            webSocketFactory: () =>
                new SockJS(
                    `${process.env.REACT_APP_WEBSOCKET_BASE_URL}${process.env.REACT_APP_API_CONTEXT}/v1/ws`
                ),

            reconnectDelay: 5000,

            debug: (msg) => {
                console.log("STOMP:", msg);
            },

            onConnect: () => {
                this.isConnected = true;
                onConnect?.();
            },

            onDisconnect: () => {
                this.isConnected = false;
                this.subscriptions.clear();
            },

            onStompError: (frame) => {
                // For example - User not authorized
                // For example - Invalid destination
                console.error("STOMP ERROR", frame);
            },

            onWebSocketError: (event) => {
                // For example - Server down
                // For example - Network issue
                console.error("WEBSOCKET ERROR", event);
            }
        });

        this.client.activate();
    }

    subscribeToTopic(
        key: string,
        destination: string,
        callback: (body: string) => void
    ) {
        if (!this.client || !this.isConnected) {
            return;
        }

        if (this.subscriptions.has(key)) {
            return;
        }

        const subscription = this.client.subscribe(
            destination,
            (message: IMessage) => {
                callback(message.body);
            }
        );

        // Stores function to stop subscription later.
        this.subscriptions.set(
            key,
            () => subscription.unsubscribe()
        );
    }

    unsubscribeTopic(key: string) {
        const unsubscribe = this.subscriptions.get(key);

        if (unsubscribe) {
            unsubscribe(); // Stops listening
            this.subscriptions.delete(key); // Remove subscription
        }
    }

    disconnect() {
        this.subscriptions.forEach(unsubscribe => unsubscribe());
        this.subscriptions.clear();  // Clear from memory too
        this.client?.deactivate(); // Closes STOMP connection
        this.client = null;
        this.isConnected = false;
    }
}

export const webSocketService = new WebSocketService();
